import {useContext} from "react";
import {DialogsContext} from "../dialogsContext";

export const useDialogs = () => useContext(DialogsContext)!;
